export const removeFileNameEnding = (str = '') => str?.length > 2 ? str.split('.').shift() : str;

export const fontName = (familyName = '', fallBackName = '') => {
  return removeFileNameEnding(familyName?.length > 2 ? familyName : fallBackName);
};

export const fontFormat = (str = '') => {
  const extension = str.split('.').pop()?.toLowerCase();
  switch (extension) {
    case 'otc':
    case 'ttc':
      return 'collection';
    case 'eot':
      return 'embedded-opentype';
    case 'otf':
      return 'opentype';
    case 'ttf':
      return 'truetype';
    case 'svg':
    case 'svgz':
      return 'svg';
    case 'woff':
    case 'woff2':
      break;
    default:
      return '';
  }
  return extension;
};
